import { useState, useEffect } from "react";
import {
    DESKTOP_1,
    DESKTOP_2,
    DESKTOP_3,
    MOBILE_1,
    MOBILE_2,
    MOBILE_3,
    TABLET_1,
    TABLET_2,
    TABLET_3,
} from "../domain/constants";

function getScreenSize() {
    const { innerWidth: width, innerHeight: height } = window;
    return {
        width,
        height,
    };
}

export default function useScreenSize() {
    const [screenSize, setScreenSize] = useState(getScreenSize());

    useEffect(() => {
        function handleResize() {
            setScreenSize(getScreenSize());
        }

        window.addEventListener("resize", handleResize);
        return () => window.removeEventListener("resize", handleResize);
    }, []);

    return {
        width: screenSize.width,
        height: screenSize.height,
        upTo390: screenSize.width < MOBILE_1,
        moreOrEqual390: screenSize.width >= MOBILE_1,
        upTo480: screenSize.width < MOBILE_2,
        moreOrEqual480: screenSize.width >= MOBILE_2,
        upTo540: screenSize.width < MOBILE_3,
        moreOrEqual540: screenSize.width >= MOBILE_3,
        upTo650: screenSize.width < TABLET_1,
        moreOrEqual650: screenSize.width >= TABLET_1,
        upTo800: screenSize.width < TABLET_2,
        moreOrEqual800: screenSize.width >= TABLET_2,
        upTo900: screenSize.width < TABLET_3,
        moreOrEqual900: screenSize.width >= TABLET_3,
        upTo1024: screenSize.width < DESKTOP_2,
        moreOrEqual1024: screenSize.width >= DESKTOP_2,
        upTo1200: screenSize.width < DESKTOP_3,
        moreOrEqual1200: screenSize.width >= DESKTOP_3,
        upTo1360: screenSize.width < DESKTOP_1,
        moreOrEqual1360: screenSize.width >= DESKTOP_1,
    };
}
